import { useState } from "react";

const CustomHeader = (props) => {
  const { displayName, setSort, column } = props;
  const [activeSort, setActiveSort] = useState("");

  const colDef = column.getColDef();
  const isSortable = colDef.sortable !== false; 

  const handleHeaderClick = () => {
    if (!isSortable) return;

    const currentSort = column.getSort();
    let nextApiSort = "";
    let nextDisplaySort = "";

    // Cycle: "" → "ASC" → "DESC" → ""
    if (!currentSort) {
      nextApiSort = "asc";
      nextDisplaySort = "ASC";
    } else if (currentSort === "asc") {
      nextApiSort = "desc";
      nextDisplaySort = "DESC";
    } else {
      nextApiSort = "";
      nextDisplaySort = "";
    }

    setSort(nextApiSort);
    setActiveSort(nextDisplaySort);
  };

  // Icon logic (only for sortable columns)
  let sortIconClass = "";
  if (activeSort === "ASC") sortIconClass = "ag-icon ag-icon-asc";
  else if (activeSort === "DESC") sortIconClass = "ag-icon ag-icon-desc";
  else sortIconClass = "ag-icon ag-icon-none";

  return (
    <div
      style={{
        cursor: isSortable ? "pointer" : "default", 
        fontSize: "13px",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        fontWeight: "700",
        textTransform: "uppercase",
        color: "#fff",
        letterSpacing: "0.5px",
        textAlign: "center",
      }}
      className="custom-header w-100 h-100 d-flex align-items-center"
      onClick={handleHeaderClick}
    >
      <span>{displayName}</span>

      
      {isSortable && (
        <span
          style={{ color: "white", marginLeft: ".5rem" }}
          className={sortIconClass}
        ></span>
      )}
    </div>
  );
};

export default CustomHeader;
